import { Typography } from "@visa/vds";
import { PACKAGE_STATE_TEXT } from "_constants/CertificationTestingConstants";
import React from "react";

const CertificationPackageState = (props) => {
    let { packageState } = props

    return (
        <Typography className={`certification-package-state packageState${packageState}`}>
            {PACKAGE_STATE_TEXT[packageState]}
        </Typography>
    )
}

export default CertificationPackageState;